<div class="insights-panel">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
        <button
            *ngFor="let tab of tabs"
            class="tab-button"
            [class.active]="isActiveTab(tab.id)"
            (click)="setActiveTab(tab.id)"
        >
            {{ tab.label }}
        </button>
    </div>

    <!-- Tab Content -->
    <div class="tile-content">
        <!-- Current Schedule Tab -->
        <div *ngIf="isActiveTab('general')" class="tab-pane">
            <div *ngIf="placement" class="insights-parent">
                <h1>General Records</h1>
                <app-general [placement]="placement"></app-general>
                <app-chick-info [placement]="placement"></app-chick-info>
                <app-trip-info [placement]="placement"></app-trip-info>
            </div>

            <!-- Show message if no placement data -->
            <div *ngIf="!placement" class="no-data-message">
                No General records found.
            </div>
        </div>

        <!-- Mortality Tab -->
        <div *ngIf="isActiveTab('mortality')" class="tab-pane">
            <div class="insights-parent">
                <div class="section-header">
                    <h1>Mortality Records</h1>
                    <button
                        *appHasRole="['Admin', 'Farm manager']"
                        class="btn-action-primary"
                        (click)="openMortalityDialog()"
                    >
                        <i class="fas fa-plus"></i> Add Mortality
                    </button>
                </div>
                <app-mortality-stats
                    [placementId]="placementId"
                ></app-mortality-stats>
                <app-mortality
                    *ngFor="let mortality of mortalities"
                    [mortality]="mortality"
                    [placement]="placement"
                >
                </app-mortality>

                <!-- Show message if no mortalities -->
                <div
                    *ngIf="!mortalities || mortalities.length === 0"
                    class="no-data-message"
                >
                    No Mortality records found.
                </div>
            </div>
        </div>

        <!-- Medication Tab -->
        <div *ngIf="isActiveTab('medication')" class="tab-pane">
            <div class="insights-parent">
                <div class="section-header">
                    <h1>Medication Records</h1>
                    <button
                        *appHasRole="['Admin', 'Farm manager']"
                        class="btn-action-primary"
                        (click)="openMedicationDialog()"
                    >
                        <i class="fas fa-plus"></i> Add Medication
                    </button>
                </div>
                <app-medication-stats
                    [placementId]="placementId"
                ></app-medication-stats>
                <app-medication-record
                    *ngFor="let medication of medications"
                    [medication]="medication"
                    [placement]="placement"
                >
                </app-medication-record>

                <!-- Show message if no medications -->
                <div
                    *ngIf="!medications || medications.length === 0"
                    class="no-data-message"
                >
                    No medication records found.
                </div>
            </div>
        </div>

        <!-- Vaccination Tab -->
        <div *ngIf="isActiveTab('vaccination')" class="tab-pane">
            <div class="insights-parent">
                <div class="section-header">
                    <h1>Vaccination Records</h1>
                    <button
                        *appHasRole="['Admin', 'Farm manager']"
                        class="btn-action-primary"
                        (click)="openVaccinationDialog()"
                    >
                        <i class="fas fa-plus"></i> Add Vaccination
                    </button>
                </div>
                <app-vaccination-stats
                    [placementId]="placementId"
                ></app-vaccination-stats>
                <app-vaccination-record
                    *ngFor="let vaccination of vaccinations"
                    [vaccination]="vaccination"
                    [placement]="placement"
                >
                </app-vaccination-record>
                <div
                    *ngIf="!vaccinations || vaccinations.length === 0"
                    class="no-data-message"
                >
                    No Vaccination records found.
                </div>
            </div>
        </div>

        <!-- Feeding Tab -->
        <div *ngIf="isActiveTab('feeding')" class="tab-pane">
            <div class="insights-parent">
                <app-feeding-record
                    [placementId]="placementId"
                ></app-feeding-record>
            </div>
        </div>
        <!-- Body Weight Tab -->
        <div *ngIf="isActiveTab('body-weight')" class="tab-pane">
            <div class="insights-parent">
                <div class="section-header">
                    <h1>Body Weight Records</h1>
                    <button
                        *appHasRole="['Admin', 'Farm manager']"
                        type="button"
                        class="btn-action-primary"
                        (click)="openBodyWeightDialog()"
                    >
                        <i class="fas fa-plus"></i> Add Body Weight
                    </button>
                </div>
                <app-body-weight-stats
                    [cycleId]="placementId"
                ></app-body-weight-stats>
                <app-body-weight-record
                    *ngFor="let averageWeight of averageWeights"
                    [averageWeight]="averageWeight"
                    [placement]="placement"
                >
                </app-body-weight-record>
                <div
                    *ngIf="!averageWeights || averageWeights.length === 0"
                    class="no-data-message"
                >
                    No Body Weight records found.
                </div>
            </div>
        </div>
        <!-- Timeline Tab -->
        <div *ngIf="isActiveTab('timeline')" class="tab-pane">
            <div class="insights-parent">
                <h1>Timeline</h1>
                <app-timeline-record
                    *ngFor="let rec of timelineRecords"
                    [record]="rec"
                >
                </app-timeline-record>
                <div
                    *ngIf="timelineRecords.length === 0"
                    class="no-data-message"
                >
                    No Timeline records found.
                </div>
            </div>
        </div>
        <!-- Performance Tab -->
        <div *ngIf="isActiveTab('performance')" class="tab-pane">
            <div class="insight-panel">
                <h1>Performance Records</h1>
                <app-performance-record
                    [apiResponse]="performance"
                ></app-performance-record>
                <div *ngIf="!performance" class="no-data-message">
                    No Performance records found.
                </div>
            </div>
        </div>
        <!-- AI Insights Tab -->
        <div *ngIf="isActiveTab('ai-insights')" class="tab-pane">
            <div *ngIf="loading" class="loading-container">
                <i class="fas fa-spinner fa-spin"></i>
                <p>Loading AI insights...</p>
            </div>

            <div *ngIf="!loading && aiInsightsData">
                <div class="ai-prediction-container">
                    <app-house-details-widget>
                        <div widget-title class="d-flex align-items-center">
                            Weight Gain Forecast
                        </div>
                        <div class="subtext">
                            Current Average Weight
                            {{ aiInsightsData.currentAverageWeight }}g
                        </div>
                        <div>
                            <div class="value">
                                Predicted Average Weight in 7 days:
                                {{
                                    aiInsightsData.averageForecast7dKg 
                                        | number: '1.1-2'
                                }}g
                            </div>
                            <!-- <div
                                class="d-flex justify-content-between align-items-center mt-2"
                            >
                                <span class="subtext">Confidence</span>
                                <span class="subtext">94%</span>
                            </div> -->
                            <!-- <p-progressBar
                                [showValue]="false"
                                [mode]="'determinate'"
                                [value]="94"
                            ></p-progressBar> -->
                        </div>
                    </app-house-details-widget>

                    <app-house-details-widget>
                        <div widget-title class="d-flex align-items-center">
                            Cycle Final Weight
                        </div>
                        <div class="subtext">
                            Current Weight Progress:
                            {{
                                aiInsightsData.weightProgress | number: '1.1-2'
                            }}%
                        </div>
                        <div>
                            <div class="value">
                                Predicted Cycle Final Weight:
                                {{
                                    aiInsightsData.finalWeightKg 
                                        | number: '1.1-2'
                                }}g
                            </div>
                            <!-- <div
                                class="d-flex justify-content-between align-items-center mt-2"
                            >
                                <span class="subtext">Confidence</span>
                                <span class="subtext">89%</span>
                            </div> -->
                            <!-- <p-progressBar
                                [showValue]="false"
                                [mode]="'determinate'"
                                [value]="89"
                            ></p-progressBar> -->
                        </div>
                    </app-house-details-widget>
                </div>

                <div
                    class="ai-insights-recommendations"
                    *ngIf="aiInsightsData.insights"
                >
                    <h2>AI Insights & Recommendations</h2>
                    <div class="insights-parent">
                        <app-ai-insight-tile
                            *ngFor="let insight of aiInsightsData.insights"
                            [insightColor]="getInsightColor(insight.severity)"
                            [insightTitle]="insight.title"
                            [insightInfo]="insight.body"
                        >
                        </app-ai-insight-tile>
                    </div>

                    <div class="ai-disclaimer">
                        <i class="fas fa-info-circle"></i>
                        <p>
                            <strong>Note:</strong> AI model is still learning
                            about your environment to improve accuracy of the
                            results
                        </p>
                    </div>
                </div>
            </div>

            <div
                *ngIf="!loading && !aiInsightsData"
                class="text-center py-4 no-data-message"
            >
                No AI insights records found.
            </div>
        </div>
    </div>
</div>
